var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6562 2.65625H2.34375C1.05141 2.65625 0 3.70766 0 5V15C0 16.2923 1.05141 17.3438 2.34375 17.3438H17.6562C18.9486 17.3438 20 16.2923 20 15V5C20 3.70766 18.9486 2.65625 17.6562 2.65625ZM18.4375 15C18.4375 15.4308 18.087 15.7812 17.6562 15.7812H2.34375C1.91297 15.7812 1.5625 15.4308 1.5625 15V8.35938H18.4375V15ZM18.4375 6.01562H1.5625V5C1.5625 4.56922 1.91297 4.21875 2.34375 4.21875H17.6562C18.087 4.21875 18.4375 4.56922 18.4375 5V6.01562Z",
    fill: "#005D9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9688 9.53125H2.65625V11.0938H12.9688V9.53125Z",
    fill: "#005D9C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.4d2052d8.svg";
export { ForwardRef as ReactComponent };